/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExcludeControls } from './ExcludeControls';
import {
    ExcludeControlsFromJSON,
    ExcludeControlsFromJSONTyped,
    ExcludeControlsToJSON,
    ExcludeControlsToJSONTyped,
} from './ExcludeControls';
import type { IncludeControls } from './IncludeControls';
import {
    IncludeControlsFromJSON,
    IncludeControlsFromJSONTyped,
    IncludeControlsToJSON,
    IncludeControlsToJSONTyped,
} from './IncludeControls';
import type { Match } from './Match';
import {
    MatchFromJSON,
    MatchFromJSONTyped,
    MatchToJSON,
    MatchToJSONTyped,
} from './Match';

/**
 * 
 * @export
 * @interface MatchingCriteria
 */
export interface MatchingCriteria {
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    description?: string;
    /**
     * 
     * @type {IncludeControls}
     * @memberof MatchingCriteria
     */
    includeControls?: IncludeControls;
    /**
     * 
     * @type {ExcludeControls}
     * @memberof MatchingCriteria
     */
    excludeControls?: ExcludeControls;
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    pattern?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    expression?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchingCriteria
     */
    matchType?: string;
    /**
     * 
     * @type {Array<Match>}
     * @memberof MatchingCriteria
     */
    matches?: Array<Match>;
}

/**
 * Check if a given object implements the MatchingCriteria interface.
 */
export function instanceOfMatchingCriteria(value: object): value is MatchingCriteria {
    return true;
}

export function MatchingCriteriaFromJSON(json: any): MatchingCriteria {
    return MatchingCriteriaFromJSONTyped(json, false);
}

export function MatchingCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchingCriteria {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'includeControls': json['includeControls'] == null ? undefined : IncludeControlsFromJSON(json['includeControls']),
        'excludeControls': json['excludeControls'] == null ? undefined : ExcludeControlsFromJSON(json['excludeControls']),
        'pattern': json['pattern'] == null ? undefined : json['pattern'],
        'expression': json['expression'] == null ? undefined : json['expression'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(MatchFromJSON)),
    };
}

export function MatchingCriteriaToJSON(json: any): MatchingCriteria {
    return MatchingCriteriaToJSONTyped(json, false);
}

export function MatchingCriteriaToJSONTyped(value?: MatchingCriteria | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'includeControls': IncludeControlsToJSON(value['includeControls']),
        'excludeControls': ExcludeControlsToJSON(value['excludeControls']),
        'pattern': value['pattern'],
        'expression': value['expression'],
        'matchType': value['matchType'],
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(MatchToJSON)),
    };
}

